import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getGridSelector } from '@store/grids';
import { GridsService } from '@services';
import { getListChildren } from '@helpers';
import { ApiGridComplete } from './api-grid-complete.component';
import { ApiGridError } from './api-grid-error.component';
import { ApiGridLoading } from './api-grid-loading.component';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ApiGrid(_ref) {
  var id = _ref.id,
      api = _ref.api,
      transformResponse = _ref.transformResponse,
      children = _ref.children,
      fakeGenerator = _ref.fakeGenerator;
  var grid = useSelector(getGridSelector(id));
  var gridState = useMemo(function () {
    var state = _objectSpread(_objectSpread({}, grid), {}, {
      fake: []
    });

    if (fakeGenerator) {
      if (typeof fakeGenerator.model === 'function') {
        var res = [];

        for (var i = 0; i < fakeGenerator.count; i += 1) {
          res.push(fakeGenerator.model(i));
        }

        state.fake = res;
      } else {
        state.fake = new Array(fakeGenerator.count).fill(fakeGenerator.model);
      }
    }

    return state;
  }, [grid, fakeGenerator]);
  var loading = useMemo(function () {
    return getListChildren(children, 'ApiGridLoading');
  }, [children]);
  var complete = useMemo(function () {
    var completeWithoutProps = getListChildren(children, 'ApiGridComplete');

    if (completeWithoutProps) {
      completeWithoutProps = completeWithoutProps.map(function (child) {
        var childObj = child;

        var childWithProps = _objectSpread(_objectSpread({}, childObj), {}, {
          props: _objectSpread(_objectSpread({}, childObj.props), {}, {
            gridState: gridState
          })
        });

        return childWithProps;
      });
    }

    return completeWithoutProps; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children, grid]);
  var error = useMemo(function () {
    return getListChildren(children, 'ApiGridError');
  }, [children]);
  useEffect(function () {
    GridsService.api(id, api, transformResponse)["catch"](function () {// Handle error
    });
    return function () {
      GridsService.close(id);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (grid) {
    return typeof children === 'function' ? children(gridState) : grid !== null && grid !== void 0 && grid.isLoading ? /*#__PURE__*/_jsx(_Fragment, {
      children: loading
    }) : grid !== null && grid !== void 0 && grid.isError ? /*#__PURE__*/_jsx(_Fragment, {
      children: error
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: complete
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {});
}

ApiGrid.Loading = ApiGridLoading;
ApiGrid.Complete = ApiGridComplete;
ApiGrid.Error = ApiGridError;
export { ApiGrid };